import type { COOKIES_COPY } from '@eliadmin/core/src/components/dlz/cookies/cookies-copy';

/**
 * The four categories of the design and the vanilla-cookieconsent categories of the core config
 * (`cookie-consent-config.tsx`) they switch. The gtag consent update of the client maps them on:
 * `functional` → functionality + personalization storage, `analytics` → analytics storage,
 * `ads` → ad storage, user data and personalization.
 */
export const COOKIE_CATEGORIES = [
  { copy: 'necessary', engine: 'necessary', readOnly: true },
  { copy: 'preferences', engine: 'functional', readOnly: false },
  { copy: 'analytics', engine: 'analytics', readOnly: false },
  { copy: 'marketing', engine: 'ads', readOnly: false },
] as const satisfies readonly {
  copy: keyof typeof COOKIES_COPY.categories;
  engine: string;
  readOnly: boolean;
}[];

export type CookieCategory = (typeof COOKIE_CATEGORIES)[number]['engine'];
